import React from 'react';

const ActiveFilters = ({ filters, onRemoveFilter, options }) => {
  if (!filters || filters.length === 0 || filters.includes('all')) {
    return null; // Don't show anything if 'all' is selected or no filters are active
  }

  const getLabel = (value) => {
    const option = options.find(opt => opt.value === value);
    return option ? option.label : value;
  };

  // Flatten filters and remove duplicates
  const flattenedFilters = filters.flat().filter((filter, index, arr) => 
    arr.indexOf(filter) === index && filter !== 'all'
  );

  // Don't show anything if no valid filters after flattening
  if (flattenedFilters.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 items-center mb-2">
      {flattenedFilters.map((filter, index) => (
        <div key={`${filter}-${index}`} className="flex items-center bg-gray-200 text-gray-700 text-sm font-medium pl-3 pr-2 py-1 rounded-full">
          <span>{getLabel(filter)}</span>
          <button onClick={() => onRemoveFilter(filter)} className="ml-2 flex items-center justify-center w-4 h-4 bg-red-500 text-white rounded-full text-xs font-bold transition-colors duration-200 hover:bg-red-700">
            &times;
          </button>
        </div>
      ))}
    </div>
  );
};

export default ActiveFilters;
